


import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Card, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Gallery.css"; // Custom CSS for hover effect
import * as Constants from '../Constants/Constants'

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get(`${Constants.BASE_URL}?apitype=105`);
        if (response.data.status && response.data.statusCode === 200) {
          setImages(response.data.mImageData); // Update to match new API response structure
        } else {
          console.error("Failed to fetch images");
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
  }, []);

  const handleShow = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  return (
    <div className="container mt-5">
      <Row>
        {images.length > 0 ? (
          images.map((image) => (
            <Col md={4} sm={6} key={image.id} className="mb-4">
              <Card className="gallery-card" onClick={() => handleShow(image)}>
                {/* Assuming the image is base64 encoded */}
                <Card.Img
                  variant="top"
                  src={`data:image/jpeg;base64,${image.image}`}
                  alt={image.title || "Image"}
                  className="hover-image"
                />
                <Card.Body>
                  <Card.Title style={{ fontSize: '1rem' }}>{image.title || ""}</Card.Title>
                  {/* <Card.Text style={{ fontSize: '0.875rem' }}>{image.created}</Card.Text> */}
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <div className="text-center mt-5">Loading images...</div>
        )}
      </Row>

      {/* Modal for displaying the full image */}
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedImage?.title || ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={`data:image/jpeg;base64,${selectedImage?.image}`}
            alt={selectedImage?.title || "Image"}
            className="img-fluid mb-3"
          />
          {/* <p>Created: {selectedImage?.created}</p> */}
          <p>{selectedImage?.descr || ""}</p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Gallery;

